export enum CompanyType {
  CSV = 'CSV',
  ASC = 'ASC',
  ASCO = 'ASCO',
  QBFS = 'QBFS',
  QBO = 'QBO',
  SFY = 'SFY',
  SHIP_STATION = 'SHIP_STATION'
}
